import React, {
  ChangeEvent,
  FC,
  FormEvent,
  HTMLInputTypeAttribute,
  memo,
  useCallback,
  useRef,
} from "react";
import { useField, FastField, useFormikContext } from "formik";
import { InputProps, TextField, styled } from "@mui/material";

interface TextInputProps {
  type?: HTMLInputTypeAttribute;
  required?: boolean;
  disabled?: boolean;
  label: string;
  fieldname: string;
  onInput?: (e: FormEvent<HTMLInputElement>) => void;
  InputProps?: InputProps;
  inputProps?: InputProps["inputProps"];
  onPaste?: (e: any) => any;
  multiline?: boolean;
  minRows?: number;
  defaultValue?: string;
  autoComplete?: string;
  value?: string;
  style?: React.CSSProperties;
  onChange?: (e: any) => any;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderColor: theme.palette.error.main,
  },
  "& .MuiFormHelperText-root.Mui-error": {
    color: theme.palette.error.main,
  },
}));

const TextInput: FC<TextInputProps> = (props) => {
  const {
    type = "text",
    required = false,
    fieldname,
    InputProps,
    inputProps,
    multiline = false,
    minRows,
    defaultValue,
    autoComplete,
    onInput,
    onPaste,
    disabled,
    style,
    onChange
  } = props;
  const [field, meta] = useField(fieldname);
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setFieldValue(field.name, event.target.value, false); // shouldValidate to false
    },
    [field.name, setFieldValue]
  );

  const handleBlurRef = useRef(false);
  const handleBlur = useCallback(() => {
    if (!handleBlurRef.current) {
      setFieldTouched(field.name, true);
      handleBlurRef.current = true;
    }
  }, [field.name, setFieldTouched]);

  // const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   setFieldValue(field.name, event.target.value, false); // shouldValidate to false
  // };

  // const handleBlurRef = useRef(false);
  // const handleBlur = useCallback(() => {
  //   if (!handleBlurRef.current) {
  //     setFieldTouched(field.name, true);
  //     handleBlurRef.current = true;
  //   }
  // }, [field.name, setFieldTouched]);

  const error = meta.touched && meta.error;

  return (
    <div style={style}>
      <FastField
        key={field.name}
        type={type}
        required={required}
        component={StyledTextField}
        name={fieldname}
        defaultValue={defaultValue}
        value={field.value}
        onChange={onChange || handleChange}
        onBlur={handleBlur}
        error={!!error}
        helperText={error || ""}
        InputProps={InputProps}
        inputProps={inputProps}
        onInput={onInput}
        onPaste={onPaste}
        // shouldUpdate={(prevValues: FormikValues, nextValues: FormikValues) => {
        //   return prevValues.value !== nextValues.value;
        // }}
        fullWidth
        variant="outlined"
        multiline={multiline}
        minRows={minRows}
        autoComplete={autoComplete}
        {...props}
      />
    </div>
  );
};

export default memo(TextInput);
